import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllCommentsService = (
  board_id: string | number,
  page: number = 1,
  limit: number = 10,
) => {
  return HTTP_CLIENT.get(
    Endpoint.comment.getAllComments.replace(":board_id", board_id.toString()),
    {
      params: {
        page,
        limit,
      },
    },
  );
};

const CreateCommentService = (board_id: string | number, data: any) => {
  return HTTP_CLIENT.post(
    Endpoint.comment.createComment.replace(":board_id", board_id.toString()),
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export { GetAllCommentsService, CreateCommentService };
